import { Tooltip } from "shared/ui/tooltip"
import { useExcel } from "../lib/hooks/useExcel"
import { DownloadIconButton } from "shared/ui/buttons/iconButtons/downloadButton";
import { Preloader } from "shared/ui/spinner";

export const ExcelDownload = () => {
  const {onClick, isLoading} = useExcel();

  return (
    <Tooltip label="Выгрузить в xlsx">
      {isLoading ? 
      <Preloader 
        $width="32px"
        $height="32px"
      />
      : <DownloadIconButton 
        onClick={onClick}
      />
      }
    </Tooltip>
  )
}